export default "__VITE_ASSET__6c3a8269__"